import "bootstrap";
import "../js/navbar";

if (import.meta.env.PROD) import("../js/sentryConfig");
